import Component from "./PuppyPoolPartyLeaderboard";

export default Component;
